import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: '',
      errorInfo: null
    };
  }

  getMailtohref() {
    const bodyMessage = "When using the gateway I experienced an error:\n\n" + JSON.stringify(this.state.error) + "\n\nWith added info:\n\n" + JSON.stringify(this.state.errorInfo);
    let result = '';
    result += "mailto:help.desk@cirencester-friendly.co.uk";
    result += "?subject=gateway%20error";
    result += "&body=" + encodeURIComponent(bodyMessage);
    return result;
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error({
      error: error,
      errorInfo: errorInfo
    });
    this.setState(
      {
        error: error,
        errorInfo: errorInfo
      }
    )
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container fluid="sm">
          <Row className='mt-2'>
            <Col>
              <h2>Something went wrong.</h2>
              <p>
                It appears something went wrong when trying to load this page.
                The following error occured:
              </p>
              <Card className="mb-2">
                <Card.Body>
                  { String(this.state.error.message) }
                </Card.Body>
              </Card>
              <p>
                If you want to report this error please include the below information:
              </p>
              <Card className="mb-2">
                <Card.Body>
                  <p>Error:</p>
                  <p>{ JSON.stringify(this.state.error) }</p>
                  <p>ErrorInfo:</p>
                  <p>{ JSON.stringify(this.state.errorInfo) }</p>
                </Card.Body>
              </Card>
              <p>
                <a target="_blank" rel="noreferrer" href={this.getMailtohref()}>
                  You can click here to send us an email to report it.
                </a><br/>
                Please include as much information as you can about what you were
                at the time the error occured. This will help us with troubleshooting.
              </p>
            </Col>
          </Row>
        </Container>
      )
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;